import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isLogin: true,
    theme: 'light',
    modal: {
      isShow: false,
      target: ''
    },
    userAccount: {
      id: '0x2AF8Ae03294d28D2098A7bcd3811Dae1e89016E3'
    },
  },
  actions: {
    onLogin ({ commit }) {
      commit('onLogin')
    },
    onLogout ({ commit }) {
      commit('onLogout')
    },
    openModal ({ commit }, target) {
      commit('openModal', { target: target })
    },
    closeModal ({ commit }) {
      commit('closeModal')
    },
    changeTheme({ commit }, theme) {
      commit('changeTheme', { theme: theme })
    },
    addAddress ({ commit }, value) {
      commit('addAddress', { value: value })
    }
  },
  mutations: {
    onLogin(state) {
      state.isLogin = true
    },
    onLogout(state) {
      state.isLogin = false
    },
    openModal(state, { target }) {
      state.modal.isShow = true
      state.modal.target = target
    },
    closeModal(state) {
      state.modal.isShow = false
      state.modal.target = ''
    },
    changeTheme(state, { theme }) {
      state.theme = theme
    },
    addAddress(state, { value }) {
      state.userAccount.id = value
      state.isLogin = true
    }
  }
})

export default store